import Vue from 'vue';
import {
  ValidationProvider, ValidationObserver, extend, configure, setInteractionMode,
} from 'vee-validate';
import {
  email, min, max, numeric,
} from 'vee-validate/dist/rules';
import moment from 'moment';

import { i18n } from '@/plugins/i18n';
import { Regex } from './utils/regex';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

configure({
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`fields.${field}`);

    return i18n.t(`validation.${values._rule_}`, values) as string;
  },
});

setInteractionMode('eager');

extend('required', {
  validate(value) {
    return {
      required: true,
      valid: ['', null, undefined, false, 0].indexOf(value) === -1,
    };
  },
  computesRequired: true,
});

extend('email', email);

extend('min', min);

extend('max', max);

extend('numeric', numeric);

/**
 * A rule to check the mobile number validity against the Saudi valid patterns.
 */
extend('mobile', {
  validate: (value: string) => value && Regex.Mobile.test(value),
});

/**
 * A rule to check the national identity validity.
 */
extend('nationalId', {
  validate: (value: string) => value && value.startsWith('1') && Regex.NationalId.test(value),
});

/**
 * A rule to check the iqama validity.
 */
extend('iqama', {
  validate: (value: string) => value && value.startsWith('2') && Regex.NationalId.test(value),
});

/**
 * A rule to check against the Saudi national identity pattern.
 */
extend('requesterNationalId', {
  validate: (value: string) => value && Regex.NationalId.test(value),
});

/**
 * A rule to check date validity.
 */
extend('date', {
  validate: (value: string) => value && value !== 'Invalid date',
});

/**
 * A rule to check if the person is greater than 18 years.
 */
extend('lessThan18', {
  validate: (value: string) => moment.duration(moment().diff(moment(value))).years() >= 18,
});

/**
 * A rule to check the minimum contract duration period.
 */
extend('minimumContractDuration', {
  validate: (value: string, { startDate }: Record<string, any>) => moment(startDate).add(90, 'days').isBefore(value),
  params: ['startDate'],
});

/**
 * A rule to check against the OTP pattern.
 */
extend('otp', {
  validate: (value: string) => value && value.length === 4 && Regex.Numbers.test(value),
});
